var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.room
    ? _c(
        "div",
        [
          _c("div", { staticClass: "d-flex justify-space-between" }, [
            _c("div", { staticClass: "va-subtitle font-bold" }, [
              _vm._v(_vm._s(_vm.$t("common.information")))
            ]),
            _c("div", { staticClass: "va-subtitle font-bold grey--text" }, [
              _vm._v(" " + _vm._s(_vm.$t("common.magoForDisplay")) + " ")
            ])
          ]),
          _c("div", { staticClass: "va-subtitle-s" }, [
            _vm._v(_vm._s(_vm.$t("common.details")))
          ]),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12", md: "6" } },
                [
                  _c(
                    "va-info-row",
                    { attrs: { label: _vm.$t("common.licenseKey") } },
                    [_vm._v(_vm._s(_vm.room.licenseKey) + " ")]
                  ),
                  _c(
                    "va-info-row",
                    { attrs: { label: _vm.$t("common.overallState") } },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex align-center" },
                        [
                          _vm.overallStateData.id === 3
                            ? _c(
                                "v-icon",
                                {
                                  staticClass: "mr-4",
                                  attrs: { small: "", color: "error" }
                                },
                                [_vm._v("mdi-alert ")]
                              )
                            : _vm._e(),
                          _c("span", { staticClass: "mr-1" }, [
                            _vm._v(_vm._s(_vm.overallStateData.label))
                          ]),
                          _c(
                            "v-icon",
                            {
                              attrs: {
                                small: "",
                                color: _vm.overallStateData.color
                              }
                            },
                            [_vm._v("vi vi-shape-oval ")]
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "va-info-row",
                    { attrs: { label: _vm.$t("common.maintenance") } },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex align-center" },
                        [
                          _c("span", { staticClass: "mr-1" }, [
                            _vm._v(
                              _vm._s(
                                _vm.room.isMaintenanceModeEnabled
                                  ? _vm.$t("common.maintenance")
                                  : _vm.$t("common.available")
                              )
                            )
                          ]),
                          _c(
                            "v-icon",
                            {
                              attrs: {
                                small: "",
                                color: _vm.room.isMaintenanceModeEnabled
                                  ? "purple"
                                  : "secondary"
                              }
                            },
                            [_vm._v("vi vi-shape-oval ")]
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "va-info-row",
                    { attrs: { label: _vm.$t("common.tags") } },
                    [
                      _vm.room.tags.length > 0
                        ? _c(
                            "div",
                            { staticClass: "text-right" },
                            _vm._l(_vm.room.tags, function(tag, index) {
                              return _c("va-chip", {
                                key: index,
                                staticClass: "ml-1 mb-1",
                                attrs: { text: tag.name, size: "s" }
                              })
                            }),
                            1
                          )
                        : _c("span", [
                            _vm._v(
                              " " + _vm._s(_vm.$t("common.noTagsApplied")) + " "
                            )
                          ])
                    ]
                  ),
                  _c(
                    "va-info-row",
                    { attrs: { label: _vm.$t("roomDetail.deviceType") } },
                    [
                      _vm.room.deviceType == "AndroidReceiver"
                        ? _c("img", {
                            staticStyle: { width: "22px" },
                            attrs: {
                              src: require("@/assets/images/deviceTypes/android.svg"),
                              alt: "android"
                            }
                          })
                        : _c("img", {
                            staticStyle: { width: "22px" },
                            attrs: {
                              src: require("@/assets/images/deviceTypes/microsoft.svg"),
                              alt: "microsoft"
                            }
                          })
                    ]
                  )
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", md: "6" } },
                [
                  _c(
                    "va-info-row",
                    { attrs: { label: _vm.$t("common.agentVersion") } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.room.workerVersion || _vm.$t("common.unknown")
                        ) + " "
                      )
                    ]
                  ),
                  _c(
                    "va-info-row",
                    { attrs: { label: _vm.$t("common.hasTouchScreen") } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.room.hasTouchScreen || _vm.$t("common.unknown")
                        ) + " "
                      )
                    ]
                  ),
                  _c(
                    "va-info-row",
                    { attrs: { label: _vm.$t("common.machineBrand") } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.room.machineBrand || _vm.$t("common.unknown")
                        ) + " "
                      )
                    ]
                  ),
                  _c(
                    "va-info-row",
                    { attrs: { label: _vm.$t("common.machineModel") } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.room.machineModel || _vm.$t("common.unknown")
                        ) + " "
                      )
                    ]
                  ),
                  _c(
                    "va-info-row",
                    {
                      attrs: { label: _vm.$t("common.machineLogConfiguration") }
                    },
                    [_vm._v(_vm._s(_vm.loglevel) + " ")]
                  )
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("div", { staticClass: "va-subtitle-s" }, [
                    _vm._v(_vm._s(_vm.$t("common.lastStatus")))
                  ]),
                  _c(
                    "va-info-row",
                    { attrs: { label: _vm.$t("common.lastStatus") } },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("formatDateTime")(_vm.room.lastUpdate)
                          ) +
                          " "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }